import apiFetch from '../apiFetch'

export default function (token, dossierId, isHistorical) {
  const body = {
    DossierId: dossierId,
    IsHistorical: isHistorical
  }
  return apiFetch({
    endPoint: 'Favorites',
    method: 'DELETE',
    body: body,
    token: token
  })
}
